import React, { Component } from 'react';
import Firebase from 'firebase';
import { Dropdown, DropdownMenu, DropdownItem, Progress } from 'reactstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { Bar, Doughnut, Line, Pie, Polar, Radar } from 'react-chartjs-2';

const brandPrimary =  '#20a8d8';

class graficoRxT extends Component {

    constructor(props) {
        super(props);
        this.state = {
            init: new Date("October 13, 2014 11:13:00"),
            end: new Date(),
            chart: {
                data: {
                    labels: [],
                    datasets: [
                        {
                            data: [],
                            label: 'N° de registros enviados',
                            backgroundColor: brandPrimary,
                            borderColor: 'rgba(255,255,255,.55)',
                        }
                    ]
                },
                options: {
                    maintainAspectRatio: false,
                    legend: {
                        display: false
                    },
                    scales: {
                        xAxes: [{
                            gridLines: {
                                color: 'transparent',
                                zeroLineColor: 'transparent'
                            },
                            ticks: {
                                fontSize: 14,
                                fontColor: '#FFF',
                            }

                        }],
                        yAxes: [{
                            display: false,
                            ticks: {
                                display: false,
                            }
                        }],
                    },
                    elements: {
                        line: {
                            borderWidth: 1
                        },
                        point: {
                            radius: 4,
                            hitRadius: 10,
                            hoverRadius: 4,
                        },
                    }
                }
            }
        };
        this.reset = this.reset.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        var version;
        var charts = this.state.chart;
        var dataRef = Firebase.database().ref("saved/" + localStorage.client_id + "/" + nextProps.formId);
        dataRef.on('value', snap => {
            version = Object.keys(snap.val())[Object.keys(snap.val()).length - 1];
            this.setState({ versiones: Object.keys(snap.val()), version: version })
        })
        var datosRef = Firebase.database().ref("saved/" + localStorage.client_id + "/" + nextProps.formId + "/" + version + "/raw/data");
        datosRef.orderByChild("global/date/device")
            .on('value', snap => {
                var reg = [];
                snap.forEach(function (childSnapshot) {
                    var date = new Date(childSnapshot.val().global.date.device);
                    date.setUTCHours(5, 5, 5, 5);
                    var time = +date;
                    reg.push(time);
                });
                var dia = 0;
                var labels = [];
                var values = [];
                var index;
                reg.map((r) => {
                    if (r !== dia) {
                        var d = new Date(r);
                        var yyyy = d.getFullYear().toString();
                        var mm = (d.getMonth() + 1).toString();
                        var dd = d.getDate().toString();
                        labels.push((dd[1] ? dd : "0" + dd[0]) + '-' + (mm[1] ? mm : "0" + mm[0]) + '-' + yyyy);
                        values.push(1);
                        dia = r;
                        index = labels.length - 1;
                    } else {
                        values[index] = values[index] + 1;
                    }
                })
                charts.data.datasets[0].data = values;
                charts.data.labels = labels;
                this.setState({ chart: charts })
            })
    }

    reset() {
        var version;
        var charts = this.state.chart;
        var dataRef = Firebase.database().ref("saved/" + localStorage.client_id + "/" + this.props.formId);
        dataRef.on('value', snap => {
            version = Object.keys(snap.val())[Object.keys(snap.val()).length - 1];
        })
        var datosRef = Firebase.database().ref("saved/" + localStorage.client_id + "/" + this.props.formId + "/" + version + "/raw/data");
        datosRef.orderByChild("global/date/device")
            .on('value', snap => {
                var reg = [];
                snap.forEach(function (childSnapshot) {
                    var date = new Date(childSnapshot.val().global.date.device);
                    date.setUTCHours(5, 5, 5, 5);
                    var time = +date;
                    reg.push(time);
                });
                var dia = 0;
                var labels = [];
                var values = [];
                var index;
                reg.map((r) => {
                    if (r !== dia) {
                        var d = new Date(r);
                        var yyyy = d.getFullYear().toString();
                        var mm = (d.getMonth() + 1).toString();
                        var dd = d.getDate().toString();
                        labels.push((dd[1] ? dd : "0" + dd[0]) + '-' + (mm[1] ? mm : "0" + mm[0]) + '-' + yyyy);
                        values.push(1);
                        dia = r;
                        index = labels.length - 1;
                    } else {
                        values[index] = values[index] + 1;
                    }
                })
                charts.data.datasets[0].data = values;
                charts.data.labels = labels;
                this.setState({ chart: charts })
            })
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextState.init !== this.state.init) {
            var version;
            var charts = this.state.chart;
            var fechaInit = new Date(nextState.init);
            var init = +fechaInit;
            var dataRef = Firebase.database().ref("saved/" + localStorage.client_id + "/" + nextProps.formId);
            var datosRef = Firebase.database().ref("saved/" + localStorage.client_id + "/" + nextProps.formId + "/" + this.state.version + "/raw/data");
            datosRef.orderByChild("global/date/device").startAt(init)
                .on('value', snap => {
                    var reg = [];
                    snap.forEach(function (childSnapshot) {
                        var date = new Date(childSnapshot.val().global.date.device);
                        date.setUTCHours(5, 5, 5, 5);
                        var time = +date;
                        reg.push(time);
                    });
                    var dia = 0;
                    var labels = [];
                    var values = [];
                    var index;
                    reg.map((r) => {
                        if (r !== dia) {
                            var d = new Date(r);
                            var yyyy = d.getFullYear().toString();
                            var mm = (d.getMonth() + 1).toString();
                            var dd = d.getDate().toString();
                            labels.push((dd[1] ? dd : "0" + dd[0]) + '-' + (mm[1] ? mm : "0" + mm[0]) + '-' + yyyy);
                            values.push(1);
                            dia = r;
                            index = labels.length - 1;
                        } else {
                            values[index] = values[index] + 1;
                        }
                    })
                    charts.data.datasets[0].data = values;
                    charts.data.labels = labels;
                    this.setState({ chart: charts })
                })
        }
        if (nextState.end !== this.state.end) {
            var version;
            var charts = this.state.chart;
            var fechaInit = new Date(nextState.init);
            var init = +fechaInit;
            var fechaEnd = new Date(nextState.end);
            var end = +fechaEnd;
            var dataRef = Firebase.database().ref("saved/" + localStorage.client_id + "/" + nextProps.formId);
            var datosRef = Firebase.database().ref("saved/" + localStorage.client_id + "/" + nextProps.formId + "/" + this.state.version + "/raw/data");
            datosRef.orderByChild("global/date/device").startAt(init).endAt(end)
                .on('value', snap => {
                    var reg = [];
                    snap.forEach(function (childSnapshot) {
                        var date = new Date(childSnapshot.val().global.date.device);
                        date.setUTCHours(5, 5, 5, 5);
                        var time = +date;
                        reg.push(time);
                    });
                    var dia = 0;
                    var labels = [];
                    var values = [];
                    var index;
                    reg.map((r) => {
                        if (r !== dia) {
                            var d = new Date(r);
                            var yyyy = d.getFullYear().toString();
                            var mm = (d.getMonth() + 1).toString();
                            var dd = d.getDate().toString();
                            labels.push((dd[1] ? dd : "0" + dd[0]) + '-' + (mm[1] ? mm : "0" + mm[0]) + '-' + yyyy);
                            values.push(1);
                            dia = r;
                            index = labels.length - 1;
                        } else {
                            values[index] = values[index] + 1;
                        }
                    })
                    charts.data.datasets[0].data = values;
                    charts.data.labels = labels;
                    this.setState({ chart: charts })
                })
        }
        if (nextState.version !== this.state.version) {
            var version;
            var charts = this.state.chart;
            var fechaInit = new Date(nextState.init);
            var init = +fechaInit;
            var fechaEnd = new Date(nextState.end);
            var end = +fechaEnd;
            var dataRef = Firebase.database().ref("saved/" + localStorage.client_id + "/" + nextProps.formId);
            var datosRef = Firebase.database().ref("saved/" + localStorage.client_id + "/" + nextProps.formId + "/" + nextState.version + "/raw/data");
            datosRef.orderByChild("global/date/device").startAt(init).endAt(end)
                .on('value', snap => {
                    var reg = [];
                    snap.forEach(function (childSnapshot) {
                        var date = new Date(childSnapshot.val().global.date.device);
                        date.setUTCHours(5, 5, 5, 5);
                        var time = +date;
                        reg.push(time);
                    });
                    var dia = 0;
                    var labels = [];
                    var values = [];
                    var index;
                    reg.map((r) => {
                        if (r !== dia) {
                            var d = new Date(r);
                            var yyyy = d.getFullYear().toString();
                            var mm = (d.getMonth() + 1).toString();
                            var dd = d.getDate().toString();
                            labels.push((dd[1] ? dd : "0" + dd[0]) + '-' + (mm[1] ? mm : "0" + mm[0]) + '-' + yyyy);
                            values.push(1);
                            dia = r;
                            index = labels.length - 1;
                        } else {
                            values[index] = values[index] + 1;
                        }
                    })
                    charts.data.datasets[0].data = values;
                    charts.data.labels = labels;
                    this.setState({ chart: charts })
                })
        }
    }

    render() {
        return (
            <div className="card card-inverse card-info">
                <div className="card-block pb-0">
                    <div className="btn-group float-right" style={{ marginRight: "40px", marginTop: "20px" }}>
                        <button
                            onClick={() => { this.setState({ card1: !this.state.card1, card2: false }); }}
                            className="btn btn-transparent active dropdown-toggle p-0"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded={this.state.card1}
                            style={{ marginRight: "2px" }}
                        >
                            <i className="fa fa-calendar" aria-hidden="true"></i>
                        </button>
                        <button onClick={() => { this.setState({ card2: !this.state.card2, card1: false }); }} className="btn btn-transparent active dropdown-toggle p-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded={this.state.card2}>
                            <i className="fa fa-history" aria-hidden="true"></i>
                        </button>
                        <div className={this.state.card1 === true ? "dropdown show" : "dropdown"}>
                            <div className={this.state.card1 === true ? "dropdown-menu show" : "dropdown-menu"} aria-labelledby="dropdownMenu2" style={{ marginLeft: "-130px" }}>
                                <button className="dropdown-item" type="button">
                                    <DatePicker
                                        placeholderText="Fecha inicio"
                                        className="form-control"
                                        onChange={(e) => { this.setState({ init: e._d }) }}
                                    />
                                </button>
                                <button className="dropdown-item" type="button">
                                    <DatePicker
                                        placeholderText="Fecha fin"
                                        className="form-control"
                                        onChange={(e) => { this.setState({ end: e._d }) }}
                                    />
                                </button>
                                <button className="dropdown-item" type="button" onClick={() => { this.reset() }}>
                                    Restaurar
                                </button>
                            </div>
                            <div className={this.state.card2 === true ? "dropdown show" : "dropdown"}>
                                <div className={this.state.card2 === true ? "dropdown-menu show" : "dropdown-menu"} aria-labelledby="dropdownMenu2" style={{ marginLeft: "-90px", marginTop: "20px" }}>
                                    {
                                        this.state.versiones ?
                                            this.state.versiones.map((v, index) => (
                                                <button key={index} className="dropdown-item" type="button" onClick={() => this.setState({ version: v })} >
                                                    Versión {v}
                                                </button>
                                            ))
                                            :
                                            ""
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <h4 className="mb-0">Registros enviados</h4>
                </div>
                <div className="chart-wrapper px-3" style={{height : "300px"}}>
                    <Bar data={this.state.chart.data} options={this.state.chart.options} />
                </div>
            </div>
        )
    }
}

export default graficoRxT;



// WEBPACK FOOTER //
// ./src/views/dashBoard/graficoRxT.js